import routeCategory from "../model/route-category"

const routeMapper = {
    toSaveDto(route) {
        return (({path, title, isRequiredAuth, category, isMenu, menuIndex, menuBadge, parentRouteId}) => ({
            path,
            title,
            isRequiredAuth,
            category,
            isMenu,
            menuIndex,
            menuBadge,
            parentRouteId
        }))(route)
    },
    toSyncDtos(routes) {
        return routes.map(route => {
            const routeDto = {}
            routeDto.path = route.path
            routeDto.title = route.title
            routeDto.isRequiredAuth = route.isRequiredAuth
            // 从前端同步时，有可能前端没有设置对是否需要授权和路由分类元数据。
            if (routeDto.isRequiredAuth) {
                routeDto.category = route.category || routeCategory.getDefaultCategory().key
            } else {
                routeDto.category = ""
            }
            routeDto.isMenu = route.isMenu
            routeDto.menuIndex = route.menuIndex
            routeDto.menuBadge = route.menuBadge
            routeDto.parentRoutePath = route.parentRoutePath

            return routeDto
        })
    }
}

export default routeMapper